import { apiClient } from './api';

export interface RevenueData {
  totalRevenue: number;
  mrr: number;
  activeTenants: number;
  avgOrderValue: number;
  revenueTrend: { date: string; value: number }[];
  topTenants?: TenantRevenueItem[];
  revenueByPlan?: PlanRevenueItem[];
}

export interface TenantRevenueItem {
  rank: number;
  tenantId: string;
  name: string;
  revenue: number;
  share: number;
}

export interface PlanRevenueItem {
  plan: string;
  revenue: number;
  percentage: number;
}

export interface GrowthMetrics {
  tenantGrowthRate: number;
  revenueGrowthRate: number;
  churnRate: number;
  arpu: number;
}

export type ReportPeriod = '7d' | '30d' | '90d' | '365d';

const unwrapEnvelope = <T>(payload: any): T => {
  if (payload?.data !== undefined) {
    return payload.data as T;
  }
  return payload as T;
};

export const reportService = {
  getPlatformRevenue: async (period: ReportPeriod): Promise<RevenueData> => {
    const response = await apiClient.get('/reports/revenue', {
      params: { period },
    });
    return unwrapEnvelope<RevenueData>(response.data);
  },

  getTenantRevenue: async (tenantId: string, period: ReportPeriod): Promise<TenantRevenueItem> => {
    const response = await apiClient.get(`/reports/revenue/${tenantId}`, {
      params: { period },
    });
    return unwrapEnvelope<TenantRevenueItem>(response.data);
  },

  getGrowthMetrics: async (period: ReportPeriod): Promise<GrowthMetrics> => {
    const response = await apiClient.get('/reports/growth', {
      params: { period },
    });
    return unwrapEnvelope<GrowthMetrics>(response.data);
  },

  exportReport: async (type: string, period: ReportPeriod): Promise<Blob> => {
    const response = await apiClient.get('/reports/export', {
      params: { type, period },
      responseType: 'blob',
    });
    return response.data.data;
  },
};

export default reportService;
